import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    lonGetMortgageAgreement,
    initialState,
} from 'app/core/models/slice/doc/lonGetMortgageAgreement'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'lonGetMortgageAgreement',
    initialState,
    reducers: {
        clearOnGetMortgageAgreement: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        setOnGetMortgageAgreement: (
            state,
            action: PayloadAction<lonGetMortgageAgreement>
        ) => {
            state = { ...action.payload }
        },
        setLonCnslCnlnNo: (state, action: PayloadAction<string>) => {
            state.lonCnslCnlnNo = action.payload
        },
        setCsncsSrn: (state, action: PayloadAction<string>) => {
            state.csncsSrn = action.payload
        },
        setDbtoCsm: (state, action: PayloadAction<string>) => {
            state.dbtoCsm = action.payload
        },
        setNofcCosnTgtPdfKcd: (state, action: PayloadAction<string>) => {
            state.nofcCosnTgtPdfKcd = action.payload
        },
        setHsmmNm: (state, action: PayloadAction<string>) => {
            state.hsmmNm = action.payload
        },
        setOnGetMortgageAgreementObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (key1 === key) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const {
    clearOnGetMortgageAgreement,
    setOnGetMortgageAgreement,
    setLonCnslCnlnNo,
    setCsncsSrn,
    setDbtoCsm,
    setNofcCosnTgtPdfKcd,
    setHsmmNm,
    setOnGetMortgageAgreementObArr,
} = slice.actions

export default slice.reducer
